<template>
  <div style="height: 100%; display: flex; flex-direction: column; overflow: hidden">
    <!-- Claim selected: show messenger for claim convo -->
    <Messenger v-if="claim.DSSClaimsID" key="claim-messenger" :convo="claim.convo" :system_object="claim" />

    <!-- No claim: AI assistant messenger -->
    <Messenger
      v-else-if="claimsAssistantConvo"
      key="ai-messenger"
      :convo="claimsAssistantConvo"
      :system_object="null"
    />

    <!-- Loading AI convo -->
    <div v-else-if="aiConvoLoading" class="ai-loading-center">
      <v-progress-circular indeterminate color="primary" size="36" />
      <span class="text-caption text-grey mt-3">Loading Claims Assistant…</span>
    </div>

    <!-- Fallback: local stats chat if AI convo failed to load -->
    <StatsChatFallback v-else />
  </div>
</template>

<script>
import Messenger from "@/components/Messenger/Messenger.vue";
import StatsChatFallback from "@/components/osClaims/StatsChatFallback.vue";
import { mapGetters } from "vuex";

export default {
  name: "CenterPanel",
  components: { Messenger, StatsChatFallback },

  data() {
    return {
      aiConvoLoading: true,
    };
  },

  computed: {
    ...mapGetters("osclaims", ["claim", "claimsAssistantConvo"]),
  },

  async mounted() {
    if (!this.claimsAssistantConvo) {
      await this.$store.dispatch("osclaims/fetchClaimsAssistantConvo");
    }
    if (!this._isDestroyed) this.aiConvoLoading = false;
  },
};
</script>

<style scoped>
.ai-loading-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 8px;
}
</style>
